module.exports = __webpack_public_path__ + "static/media/creditcards.47f8b620.jpg";